import React from "react";
import { Link } from "react-router-dom";
import bots from "../botsData";
import BotAvatarGrid from "../components/BotAvatarGrid";
import DiscordCommunityIndicator from "../components/DiscordCommunityIndicator";
import HostingPartners from "../components/HostingPartners";

const Home = () => {
  return (
    <div className="min-h-full flex flex-col">
      <main className="flex-1">
        {/* Hero Section */}
        <section className="relative overflow-hidden border-b border-apb-border-soft apb-surface-glass">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_12%_18%,rgba(162,77,255,0.25),transparent_42%),radial-gradient(circle_at_88%_0%,rgba(34,216,255,0.22),transparent_36%)]" />
          <div className="pointer-events-none absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-transparent via-apb-accent-cyan to-transparent opacity-55" />
          <div className="pointer-events-none absolute right-12 top-8 h-52 w-52 rounded-full border border-apb-accent-cyan/35 shadow-[0_0_0_1px_rgba(34,216,255,0.25),0_0_26px_rgba(34,216,255,0.25)]" />
          <div className="pointer-events-none absolute left-10 bottom-8 h-44 w-44 rounded-full border border-apb-accent-purple/25 shadow-[0_0_0_1px_rgba(162,77,255,0.2),0_0_24px_rgba(162,77,255,0.2)]" />
          <div className="pointer-events-none absolute left-0 top-1/2 h-full w-full opacity-12">
            <div className="absolute h-full w-full bg-[linear-gradient(to_right,transparent_0%,rgba(255,255,255,0.14)_2px,transparent_2px,transparent_52px),linear-gradient(to_bottom,transparent_0%,rgba(255,255,255,0.14)_2px,transparent_2px,transparent_52px)] bg-[length:40px_40px,40px_40px]" />
          </div>

          <div className="relative z-10 mx-auto flex max-w-5xl flex-col items-center px-6 py-20 text-center md:py-24">
            <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-apb-border-soft bg-black/30 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.22em] text-apb-text-secondary">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-apb-accent-cyan apb-glow-cyan" />
              Next-generation Discord automation network
            </p>

            <h1 className="max-w-4xl text-4xl leading-tight font-black tracking-tight text-white md:text-6xl md:leading-none apb-glow-text">
              Elevate Your Discord Experience with Afterparty Bots
            </h1>
            <p className="mt-6 max-w-3xl text-lg text-apb-text-secondary md:text-xl">
              Find, explore, and invite top bots for your server.
            </p>

            {/* Tagline (bot count is dynamic) */}
            <div className="mt-10 flex flex-col items-center gap-5">
              <h2 className="text-2xl md:text-3xl font-bold text-white">
                Build great things with total freedom
              </h2>
              <p className="text-base md:text-lg text-apb-text-secondary">
                Started our first bot in{" "}
                <span className="font-semibold text-apb-accent-cyan apb-glow-text">2023</span>, expanded in{" "}
                <span className="font-semibold text-apb-accent-cyan apb-glow-text">2025</span>, now hosting{" "}
                <span className="font-semibold text-apb-accent-cyan apb-glow-text">{bots.length}</span> bots!
              </p>

              <div className="mt-2 flex flex-wrap justify-center gap-3">
                <Link
                  to="/support-us"
                  className="apb-btn apb-glow-purple px-6 py-3 text-sm font-semibold tracking-wide"
                >
                  Support the Network
                </Link>
                <Link
                  to="/about"
                  className="rounded-lg border border-apb-border-soft px-6 py-3 text-sm font-semibold tracking-wide text-white/90 transition-all duration-240 hover:border-apb-accent-cyan hover:text-white hover:bg-white/10 focus-ring-neo"
                >
                  Our Mission
                </Link>
              </div>
            </div>

            <DiscordCommunityIndicator />
          </div>
        </section>

        {/* Circular avatars section */}
        <BotAvatarGrid />
        <HostingPartners />
      </main>
    </div>
  );
};

export default Home;

